import type { StateContext } from '@ngxs/store';
import type { AnomalySeries } from 'commons';
import { produce } from 'immer';
import { catchError, of, tap } from 'rxjs';
import type { AnomalyService } from '../../../../services/api/anomaly.service';
import { type GetAnomaliesByChannel, GetAnomaliesSUCCESS } from '../actions/anomalies.actions';
import type { MultiViewStateModel } from '../MultiViewStateModel';
import { getViewIndex } from '.';

export namespace AnomalieActionHandler {
  /**
   * @param ctx
   * @param param1
   */
  export function getAnomalies_SUCCESS(ctx: StateContext<MultiViewStateModel>, { anomalies }: GetAnomaliesSUCCESS) {
    if (!anomalies) {
      throw new Error('No Anomalies in Action passed');
    }
    const newAnomaliesMap: { [x: string]: AnomalySeries[] } = anomalies.reduce(
      (pre, cur) => {
        if (pre[cur.channelIdentifier]) {
          pre[cur.channelIdentifier].push(cur);
          return { ...pre };
        } else {
          const c: { [x: string]: AnomalySeries[] } = {};
          c[cur.channelIdentifier] = [cur];
          return { ...pre, ...c };
        }
      },
      {} as { [x: string]: AnomalySeries[] }
    );

    const i = getViewIndex(ctx);
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        draft.views[i].kpiTable = {
          ...draft.views[i].kpiTable,
          ...newAnomaliesMap,
        };
      })
    );
  }
  /**
   *
   * @param ctx
   * @param param1
   * @param anomaliesService
   * @returns
   */
  export function getByChannel(ctx: StateContext<MultiViewStateModel>, { node }: GetAnomaliesByChannel, anomaliesService: AnomalyService) {
    return anomaliesService
      .getAnomaliesByChannel(node.id, {
        start: new Date(node.entity.firstTimestamp),
        end: new Date(node.entity.latestTimestamp),
      })
      .pipe(
        tap((anomalies) => ctx.dispatch(new GetAnomaliesSUCCESS(anomalies))),
        catchError(() => {
          return of([]);
        })
      );
  }
}
